import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { KpiEffects } from '@dashboards/effects/kpi.effects';
import { AdministrationEffects } from '@main-application/administration/effects/administration.effects';
import * as fromAdministration from '@main-application/administration/reducers/administration.reducer';
import { SystemConfigurationEffects } from '@main-application/management/components/system-configuration/store/system-configuration.effects';
import * as fromSystemConfiguration from '@main-application/management/components/system-configuration/store/system-configuration.reducer';
import { TurnoverConfigurationStoreModule } from '@main-application/management/components/turnover-configuration/store/turnover-configuration-store.module';
import { BulkBidsEffects } from '@main-application/turnovers/effects/bulk-bids.effects';
import { PunchEffects } from '@main-application/turnovers/effects/punch.effects';
import { TurnoverBidsEffects } from '@main-application/turnovers/effects/turnover-bids.effects';
import { TurnoversEffects } from '@main-application/turnovers/effects/turnovers.effects';
import * as fromBulkBids from '@main-application/turnovers/reducers/bulk-bids.reducer';
import * as fromPunch from '@main-application/turnovers/reducers/punch.reducer';
import {
  turnoverBidsFeatureKey,
  turnoverBidsReducer,
} from '@main-application/turnovers/reducers/turnover-bids.reducer';
import * as fromTurnovers from '@main-application/turnovers/reducers/turnovers.reducer';
import { PortfolioStoreModule } from '@portfolio/store/portfolio-store.module';
import { TemplateStoreModule } from '@template/store/template-store.module';

import { DashboardEffects } from './effects/dashboard.effects';
import * as fromDashboardFilterReducer from './reducers/dashboard-filter.reducer';
import { metaDashboardFilterReducers } from './reducers/dashboard-filter.reducer';
import * as fromDashboardsReducer from './reducers/dashboards.reducer';
import { metaDashboardReducers } from './reducers/dashboards.reducer';
import * as fromDashboardKpiReducer from './reducers/kpi.reducer';
import { metaDashboardKpiReducers } from './reducers/kpi.reducer';
import * as fromDashboardFilterTransient from './store';

@NgModule({
  exports: [],
  imports: [
    PortfolioStoreModule,
    TurnoverConfigurationStoreModule,
    TemplateStoreModule,
    EffectsModule.forFeature([
      DashboardEffects,
      KpiEffects,
      AdministrationEffects,
      TurnoversEffects,
      BulkBidsEffects,
      PunchEffects,
      SystemConfigurationEffects,
      TurnoverBidsEffects,
    ]),
    StoreModule.forFeature(fromSystemConfiguration.systemConfigurationFeatureKey, fromSystemConfiguration.reducer),
    StoreModule.forFeature(fromDashboardsReducer.dashboardsFeatureKey, fromDashboardsReducer.reducer, {
      metaReducers: metaDashboardReducers,
    }),
    StoreModule.forFeature(fromDashboardKpiReducer.kpiFeatureKey, fromDashboardKpiReducer.reducer, {
      metaReducers: metaDashboardKpiReducers,
    }),
    StoreModule.forFeature(fromDashboardFilterReducer.dashboardFilterFeatureKey, fromDashboardFilterReducer.reducer, {
      metaReducers: metaDashboardFilterReducers,
    }),
    StoreModule.forFeature(fromAdministration.administrationFeatureKey, fromAdministration.reducer),
    StoreModule.forFeature(fromTurnovers.turnoversFeatureKey, fromTurnovers.reducer),
    StoreModule.forFeature(fromBulkBids.bulkBidsFeatureKey, fromBulkBids.reducer),
    StoreModule.forFeature(fromPunch.punchFeatureKey, fromPunch.reducer),
    StoreModule.forFeature(
      fromDashboardFilterTransient.dashboardFilterTransientFeatureKey,
      fromDashboardFilterTransient.reducer
    ),
    StoreModule.forFeature(turnoverBidsFeatureKey, turnoverBidsReducer),
  ],
  declarations: [],
})
export class SharedStoreModule {}
